export default __webpack_public_path__ + "static/media/happyclient4.d2ac42d1.svg";